// import Vue from 'vue';
import Home from "./Home.vue";
import router from "./router";
import { Vue, i18n, initSentry } from "@/public/utils/customVue";
import store from "./store";
import { addJs } from "@/public/utils/tool";

import locale from "iview/src/locale/index";
import {
    AutoComplete,
    BackTop,
    Badge,
    Button,
    Checkbox,
    Col,
    DatePicker,
    Divider,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Form,
    FormItem,
    Icon,
    Input,
    InputNumber,
    Modal,
    Message,
    Option,
    Page,
    Radio,
    RadioGroup,
    Row,
    Select,
    Slider,
    Spin,
    Table,
    Tabs,
    TabPane,
    Time,
    Tooltip,
    Upload,
    Switch,
} from "iview";

import "iview/dist/styles/iview.css";
import "@/public/css/globalVar.css";
import "@/public/css/a.styl";
import "@/home/style/workmenu-en.styl";
import "@/home/style/fileview.styl";
import VueShepherd from "vue-shepherd";
import appConfig from "@/public/globalConfig";
import VueCropper from "vue-cropper";
import { EDRAWMAX_USE_PRODUCTRECOMMEND, EDRAWMAX_PRODUCT_ENV } from "@/env/";
import EDModal from "@/public/components/EDModal/edmodal.vue";
import { urls } from "@/public/utils/env.js";
declare const microsoftTeams: any;

initSentry();

const iViewComponent = [
    AutoComplete,
    Badge,
    Button,
    Checkbox,
    Col,
    Divider,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    FormItem,
    Icon,
    Input,
    InputNumber,
    Modal,
    Message,
    Option,
    Page,
    Radio,
    RadioGroup,
    Row,
    Select,
    Slider,
    Spin,
    Table,
    Tabs,
    TabPane,
    Time,
    Tooltip,
    Upload,
];
sessionStorage.removeItem("showAiRecommend");
function toIview18n(path, options) {
    let value = i18n.t(path, options);
    if (value !== null && value !== undefined) {
        return value;
    }
    return "";
}
locale.i18n(toIview18n);

(InputNumber as any).computed.precisionValue = function () {
    let arr = (this.currentValue + "").split(".");
    if (this.precision && arr[1] && this.precision < arr[1].length) return this.currentValue.toFixed(this.precision);
    return this.currentValue;
};
iViewComponent.forEach((c) => {
    Vue.component(c.name, c);
});
Vue.component("BackTop", BackTop);
Vue.component("DatePicker", DatePicker);
Vue.component("Form", Form);
Vue.component("iSelect", Select);
Vue.component("iOption", Option);
Vue.component("iSwitch", Switch);
Vue.component("iButton", Button);
Vue.component("iCol", Col);
Vue.component("iForm", Form);
Vue.component("iInput", Input);
Vue.component("iTable", Table);
Vue.component("EDModal", EDModal);
Vue.use(VueCropper);

Vue.prototype.$Modal = Modal;
Vue.prototype.$Message = Message;
Vue.prototype.$IVIEW = {
    size: "",
    transfer: "",
    select: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
    },
    cell: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
    },
    menu: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
    },
    tree: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
    },
    cascader: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
        itemArrow: "",
        customItemArrow: "",
        itemArrowSize: "",
    },
    colorPicker: {
        arrow: "",
        customArrow: "",
        arrowSize: "",
    },
    datePicker: {
        icon: "",
        customIcon: "",
        iconSize: "",
    },
    timePicker: {
        icon: "",
        customIcon: "",
        iconSize: "",
    },
    tabs: {
        closeIcon: "",
        customCloseIcon: "",
        closeIconSize: "",
    },
    modal: {
        maskClosable: "",
    },
};

//   Vue.component('TimePicker', TimePicker);
//   Vue.component('iSwitch', Switch)

// Vue.use(iView, {
//     i18n: function (path, options) {
//         let value = i18n.t(path, options);
//         if (value !== null && value !== undefined) {
//             return value;
//         }
//         return "";
//     },
// });
if (Vue.prototype.$Message) {
    // 重写iview destory 方法
    Vue.prototype.$Message.destroy = () => {
        Vue.prototype.$edMessage.destroy();
    };
} else {
    Vue.prototype.$Message = {};
    Vue.prototype.$Message.destroy = Vue.prototype.$edMessage.destroy;
}
import iconSymbol from "@/app/components/Symbol.vue";

import "shepherd.js/dist/css/shepherd.css";
Vue.use(VueShepherd);
//多语言
import * as vClickOutside from "v-click-outside-x";
Vue.use(vClickOutside);

import VueLazyload from "vue-lazyload";

const loadingImage = require("@/home/assets/img/newPage/recommend/img-lazy-loading.svg");
const errorImage = require("@/home/assets/img/newPage/recommend/img-lazy-error.svg");

Vue.use(VueLazyload, {
    loading: loadingImage,
    error: errorImage,
});
import VipIcon from "@/app/components/Common/VipIcon.vue";
Vue.component("VipIcon", VipIcon);

/**
 * how to use
 * <div v-transfer-dom :data-transfer="true" />
 */
import TransferDom from "@/public/utils/transfer-dom.js";
Vue.directive("transfer-dom", TransferDom);

Vue.component("iconSymbol", iconSymbol);
Vue.config.productionTip = false;
/**
 * inclowdz
 */
let isInclowdz = sessionStorage.getItem("isInclowdz");
const isWorkwx = EDRAWMAX_PRODUCT_ENV == "workwx";
const isTeamsApp = EDRAWMAX_PRODUCT_ENV == "teamsapp";
declare module "vue/types/vue" {
    interface Vue {
        $edApi: any;
        $track: any;
        $gaTrack: any;
        $openFile: any;
        $isBiggerVersion: any;
        $validateLogin: any;
        $edMessage: any;
        $edModal: any;
        lang: any;
        params: any;
        isPC: boolean;
        internal: any;
        vip: any;
        pid: string;
        fuser: any;
        platform: string;
        isInclowdz: any;
        isPlugin: any;
        isBoard: any;
        isWorkwx: any;
        openInTabs: any;
        isPCDarkMode: number;
        sensors: {
            quick: Function;
            track: Function;
            registerPage: Function;
        };
        isPrivate: boolean;
        isTeamsApp: boolean;
        isFullCouldSpace: boolean;
        OSSAccessKeyId: string;
        utm_term: string;
        appPid: number;
    }
}
let isPC = false;
let platform = "";

export const isPwa = window.matchMedia("(display-mode: standalone)").matches || window.navigator["standalone"];

declare var QWebChannel: any;
declare var qt: any;
let plugin = {};
plugin["install"] = function (Vue) {
    Vue.mixin({
        computed: {
            params() {
                return this.$store && this.$store.state.userInfo && this.$store.getters.apiParam;
            },
            isPCDarkMode() {
                return this.$store.state.isPCDarkMode;
            },
            showProductRecommend() {
                // 是否展示推荐信息
                return EDRAWMAX_USE_PRODUCTRECOMMEND;
            },
        },
    });
};
Vue.use(plugin as any);
Vue.prototype.$isBiggerVersion = isBiggerVersion;
Vue.prototype.pcThemeChange = setPcTheme;
window["app"] = { $v_: 1 };
if (typeof (<any>window).qt !== "undefined") {
    isPC = true;
    addJs(appConfig["sourcePath"] + "js/3rd/qwebchannel.js", () => {
        new QWebChannel((<any>window).qt.webChannelTransport, (channel) => {
            (<any>window).$qt = channel.objects.qtsdk;
            // getWebUserInfo是C++代码里的同名方法，该方法调用结束后会将用户信息传入回调
            (<any>window).$qt.webUserInfo((userData) => {
                console.log("$$$$$$$$$$$$$$$$");
                console.log(userData);
                (<any>window).userData = userData;
                newApp();
                platform = JSON.parse(userData).platform;
            });
        });
    });
} else if (typeof (<any>window).$qt !== "undefined") {
    isPC = true;
    (<any>window).$qt.webUserInfo((userData) => {
        console.log("$$$$$$$$$$$$$$$$");
        console.log(userData);
        (<any>window).userData = userData;
        newApp();
        platform = JSON.parse(userData).platform;
    });
} else {
    if (typeof window["$edAuth"] === undefined) {
        let authSrc = `${urls.accountUrl}/utils/edauth.js`;
        addJs(authSrc, () => {
            newApp();
        });
    } else {
        newApp();
    }
}

function setPcTheme(data) {
    localStorage.setItem("themeColor", "" + data);
    Vue.prototype.$bus.$emit("themeChange");
}
function isBiggerVersion(targetVersion) {
    // 当前版本大于传入版本则返回true
    let vList = this.$store.state.pcVersion.split(".");
    if (vList.legnth < 3) {
        return false;
    }
    let tList = targetVersion.split(".");
    vList = vList.map((a) => ~~a);
    tList = tList.map((a) => ~~a);
    if (vList[0] > tList[0]) return true;
    if (vList[0] == tList[0]) {
        if (vList[1] > tList[1]) {
            return true;
        } else if (vList[1] == tList[1]) {
            if (vList[2] >= tList[2]) {
                return true;
            }
        }
    }
    return false;
}

Vue.config.errorHandler = function (err, vm, info) {
    if (err && err.name.toLocaleLowerCase() === "quotaexceedederror") {
        // 处理 local storage 超出限制报错
        localStorage.setItem("CacheRenderLibrary", JSON.stringify([]));
    } else {
        // 其他错误仍需要将 err throw 出去
        throw err;
    }
};

function newApp() {
    Object.defineProperties(Vue.prototype, {
        isPC: {
            get: () => {
                return isPC;
            },
        },
        platform: {
            get: () => {
                return platform;
            },
        },
        isInclowdz: {
            get: () => {
                return isInclowdz == "1";
            },
        },
        openInTabs: {
            // 控制新建页面于当前页打开
            get: () => {
                return isInclowdz == "1" || isWorkwx || isTeamsApp;
            },
        },
    });

    window["app"] = new Vue({
        router,
        store,
        i18n,
        render: (h) => h(Home),
    }).$mount("#app");

    if (isTeamsApp && window["microsoftTeams"]) {
        microsoftTeams.initialize();
        microsoftTeams.appInitialization.notifySuccess();
    }
}
